{
  "version": 1,
  "asset_id": "abf921d1-2aaf-4c83-90e7-cf1e9cce73ec",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/abf921d1-2aaf-4c83-90e7-cf1e9cce73ec/sleeve-to-bypass-dissection-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/abf921d1-2aaf-4c83-90e7-cf1e9cce73ec/sleeve-to-bypass-dissection-320.webp",
  "original_filename": "sleeve-to-bypass-dissection-320.webp",
  "size": 9976,
  "content_type": "image/webp",
  "created_at": "2026-10-05T18:59:27Z"
}
